// Generated share images (1200x630) for every public page.
//
// Each PNG is rendered from the postal-collage banner plus a paper card
// carrying that page's eyebrow, headline and subline — the same visual
// grammar the proposal previews use — and lives on the CDN as an
// `.asset.json` pointer in `src/assets/og/`.

const SITE = "https://vibing.inc";

type Pointer = { url: string };

const pointers = import.meta.glob<{ default: Pointer }>("../assets/og/*.png.asset.json", {
  eager: true,
});

const byKey: Record<string, string> = {};
for (const [path, mod] of Object.entries(pointers)) {
  const key = path.split("/").pop()!.replace(".png.asset.json", "");
  byKey[key] = mod.default.url;
}

/** Absolute URL of a generated share image, or the homepage card as fallback. */
export function ogImage(key: string): string {
  const url = byKey[key] ?? byKey["home"];
  return url ? `${SITE}${url}` : `${SITE}/favicon.ico`;
}

/** True when a generated card exists for this key. */
export function hasOgImage(key: string): boolean {
  return Boolean(byKey[key]);
}

/**
 * The four tags every share surface needs, kept identical across routes.
 * Pass a generated key (e.g. "library") or an absolute URL.
 */
export function ogImageMeta(keyOrUrl: string, alt: string) {
  const url = keyOrUrl.startsWith("http") ? keyOrUrl : ogImage(keyOrUrl);
  return [
    { property: "og:image", content: url },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:alt", content: alt },
    { name: "twitter:image", content: url },
    { name: "twitter:image:alt", content: alt },
  ];
}

/** Library category / subcategory / tag hubs fall back to their parent shelf. */
export function hubOgKey(categorySlug?: string | null): string {
  if (categorySlug && hasOgImage(`hub-${categorySlug}`)) return `hub-${categorySlug}`;
  return "library";
}

/** Round-up cards are keyed by list slug. */
export function bestOgKey(slug: string): string {
  // List slugs already carry the "best-" prefix in some routes, not in others.
  const bare = slug.replace(/^best-/, "");
  if (hasOgImage(`best-${bare}`)) return `best-${bare}`;
  return "library-best";
}
